import { render, staticRenderFns } from "./hydro-spravodajstvo.vue?vue&type=template&id=7d60cfa0&"
import script from "./hydro-spravodajstvo.vue?vue&type=script&lang=js&"
export * from "./hydro-spravodajstvo.vue?vue&type=script&lang=js&"
import style0 from "./hydro-spravodajstvo.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports